import React, {useState, useEffect, useCallback, useRef} from 'react';
import {Card, Typography, Statistic, message, Button} from 'antd';
import TesterPaginator from "../components/Tester/TesterPaginator";
import {useParams} from "react-router-dom";
import axios from "axios";
import {API_BASE_URL, TEST_TIME} from "../config";
import MathText from "../components/MathText";
import StartModal from "../components/Tester/StartModal";
import FinishModal from "../components/Tester/FinishModal";
import StopModal from "../components/Tester/StopModal";
import {LeftOutlined, RightOutlined} from "@ant-design/icons";

const {Text} = Typography;
const {Countdown} = Statistic;

const CollectionTest = () => {
    const {id} = useParams();

    const scrollRef = useRef(null);


    const answerTransform = {
        "variant1": "A", "variant2": "B", "variant3": "C", "variant4": "D",
    }

    const [pages, setPages] = useState([]);
    const [questions, setQuestions] = useState(() => {
        const savedQuestions = localStorage.getItem('questions');
        const res = savedQuestions ? JSON.parse(savedQuestions) : {}
        const x = Array.from({length: Object.keys(res).length}, (_, i) => ({
            key: i + 1, id: res[i + 1]?.id
        }))
        setPages(x);
        return res
    })
    const [current, setCurrent] = useState(1);
    const [currentQuestion, setCurrentQuestion] = useState({});
    const [answers, setAnswers] = useState(() => {
        const savedAnswers = localStorage.getItem('answers');
        return savedAnswers ? JSON.parse(savedAnswers) : {};
    });
    const [modalVisible, setModalVisible] = useState(() => {
        const savedModalVisible = localStorage.getItem('modalVisible');
        return savedModalVisible ? JSON.parse(savedModalVisible) : true
    });
    const [stopModalVisible, setStopModalVisible] = useState(false)
    const [finishModalVisible, setFinishModalVisible] = useState(false)
    const [finishMessage, setFinishMessage] = useState("Vaqtingiz tugadi! Natija telegram orqali yuboriladi!")
    const [deadline, setDeadline] = useState(() => {
        const savedDeadline = localStorage.getItem('deadline');
        return savedDeadline ? JSON.parse(savedDeadline) : undefined
    });


    useEffect(() => {

        const reset = () => {
            if (deadline < Date.now()) {
                localStorage.removeItem('questions');
                localStorage.removeItem('answers');
                localStorage.removeItem('modalVisible');
                localStorage.removeItem('deadline');
                setPages([]);
                setQuestions({});
                setAnswers({});
                setCurrent(1);
                setCurrentQuestion({});
                setDeadline(undefined);
                setModalVisible(true);
            }
        };

        reset();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(() => {
        localStorage.setItem('answers', JSON.stringify(answers));
    }, [answers]);
    useEffect(() => {
        const fetchQuestions = async () => {
            try {
                const token = localStorage.getItem("token");

                const {data} = await axios.get(
                    `${API_BASE_URL}/api/Test?CollectionId=${id}`,
                    {
                        headers: {
                            'Authorization': `Bearer ${token}`
                        }
                    }
                );
                const transformed = {};
                data.forEach((item, index) => {
                    transformed[index + 1] = item;
                });
                // setPages(Array.from({length: data.length}, (_, i) => i + 1))
                const x = Array.from({length: Object.keys(data).length}, (_, i) => ({
                    key: i + 1, id: data[i]?.id
                }))
                setPages(x);
                setQuestions(transformed);
                setCurrentQuestion(transformed[current])
                localStorage.setItem('questions', JSON.stringify(transformed))
            } catch (error) {
                message.error('Error fetching questions');
            }
        };

        localStorage.setItem('modalVisible', modalVisible);
        const d = localStorage.getItem('deadline');
        if (!d && !modalVisible) {
            const newD = Date.now() + TEST_TIME
            localStorage.setItem('deadline', newD);
            setDeadline(newD)
        }
        const qs = localStorage.getItem('questions');
        const x = qs === null && !modalVisible
        if (x) {
            fetchQuestions()
            setCurrentQuestion(questions[current])
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [modalVisible])
    useEffect(() => {
        setCurrentQuestion(questions[current])
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [current])
    const selectAnswer = (questionId, variantKey) => {
        setAnswers(prev => ({...prev, [questionId]: variantKey}));
        console.log("ans:", answers)
    };

    const scrollLeft = () => {
        if (scrollRef.current) {
            scrollRef.current.scrollBy({
                left: -150,
                behavior: 'smooth'
            });
        }
    };

    const scrollRight = () => {
        if (scrollRef.current) {
            scrollRef.current.scrollBy({
                left: 150,
                behavior: 'smooth'
            });
        }
    };
    const handleFinish = useCallback(async () => {
            const savedAnswers = localStorage.getItem('answers');
            const ans = savedAnswers ? JSON.parse(savedAnswers) : {};
            const answerRequest = Object.keys(ans).map((questionId) => {
                return {
                    questionId: parseInt(questionId),
                    answer: answerTransform[ans[questionId]]
                };
            });
            console.log(answerRequest)
            if (answerRequest.length !== 0) {
                try {
                    const token = localStorage.getItem("token")
                    const response = await axios.post(
                        `${API_BASE_URL}/api/Results`,
                        {
                            collectionId: id,
                            answers: answerRequest
                        },
                        {
                            headers: {
                                'Accept': '*/*',
                                'Authorization': `Bearer ${token}`,
                                'Content-Type': 'application/json'
                            }
                        }
                    );

                    console.log('Yuborildi:', response.data);
                } catch (error) {
                    console.error('Xatolik:', error);
                }
            }

            // message.warning("Time is up! Submitting the test...");
            localStorage.removeItem('questions');
            localStorage.removeItem('answers');
            localStorage.removeItem('modalVisible');
            localStorage.removeItem('deadline');
            setFinishModalVisible(true)
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [answers]
    )
    return (<div>
        <Card>
            <div style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                height: 85,
                padding: 10,
                background: '#fff',
                borderBottom: '1px solid #eee',
                zIndex: 100,
                textAlign: 'center',
                marginBottom: 15
            }}>
                <div style={{
                    display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 12, marginTop: 24
                }}>
                    <Countdown value={deadline} onFinish={() => handleFinish()} format="HH:mm:ss"/>
                    <Button
                        danger
                        onClick={() => setStopModalVisible(true)}
                    >
                        To'xtatish
                    </Button>

                </div>
            </div>

            <div style={{
                marginTop: '80px', marginBottom: '80px'
            }}>
                <Text
                    style={{
                        fontSize:"clamp(16px, 4vw, 20px)",
                        fontFamily: "Times New Roman"
                    }}
                    strong>{current} - savol</Text>
                <div style={{
                    fontSize: "clamp(16px, 4vw, 20px)",
                    marginTop: 10
                }}>
                    <MathText
                        style={{
                            fontFamily: 'Times New Roman',
                            fontWeight: 'normal'
                        }}
                        text={currentQuestion?.content}/>
                </div>

                {["variant1", "variant2", "variant3", "variant4"].map((key, idx) => (<Card.Grid
                    key={key}
                    style={{
                        width: '100%',
                        marginTop: 10,
                        textAlign: 'left',
                        cursor: 'pointer',
                        border: answers[currentQuestion?.id] === key ? '2px solid #1677ff' : undefined,
                        color: answers[currentQuestion?.id] === key ? '#1677ff' : undefined,
                        display: 'flex',
                        borderRadius: 8
                    }}
                    onClick={() => selectAnswer(currentQuestion?.id, key)}
                >
                    <div style={{
                        display: "inline-flex",
                        justifyContent: "center",
                        alignItems: "center",
                        width: "30px",
                        height: "30px",
                        border: "1px solid",
                        borderColor: answers[currentQuestion?.id] === key ? '#1677ff' : '#f0f0f0ff',
                        borderRadius: "50%",
                        fontFamily: "Arial, sans-serif",
                        marginRight: "10px"
                    }}>{String.fromCharCode(65 + idx)}</div>
                    <div style={{fontSize: "clamp(18px, 4vw, 22px)",}}>
                        <MathText
                            text={currentQuestion?.[key]}/>

                    </div>
                </Card.Grid>))}
            </div>
            <div
                style={{
                    position: 'fixed',
                    bottom: 0,
                    left: 0,
                    right: 0,
                    padding: 12,
                    background: '#fff',
                    borderTop: '1px solid #eee',
                    zIndex: 100
                }}
            >
                <div
                    style={{
                        display: "flex"
                    }}
                >
                    <div style={{
                        display: "inline-table",
                        padding: "12px 0px 12px 12px",
                        scrollbarWidth: "none",
                        boxShadow: "3px 0 1px -1px rgba(0, 0, 0, 0.15)",
                        zIndex:10
                    }}>
                        <Button
                            key={"page.key"}
                            className="left-button nav-button"
                            onClick={scrollLeft}
                        >
                            <LeftOutlined/>
                        </Button>
                    </div>

                    <TesterPaginator
                        pages={pages}
                        setCurrent={setCurrent}
                        answers={answers}
                        finish={finishModalVisible}
                        scrollRef={scrollRef}
                    />
                    <div style={{
                        display: "inline-table",
                        padding: "12px 12px 12px 0px",
                        scrollbarWidth: "none",
                        boxShadow: "-3px 0 1px -1px rgba(0, 0, 0, 0.15)",
                        zIndex:10
                    }}>
                        <Button
                            key={"page.key"}
                            className="left-button nav-button"
                            onClick={scrollRight}
                        >
                            <RightOutlined/>
                        </Button>
                    </div>
                </div>

            </div>
        </Card>
        <StartModal modalVisible={modalVisible} setModalVisible={setModalVisible}/>
        <FinishModal
            modalVisible={finishModalVisible}
            setModalVisible={setFinishModalVisible}
            finishMessage={finishMessage}
        />
        <StopModal
            modalVisible={stopModalVisible}
            setModalVisible={setStopModalVisible}
            setFinishMessage={setFinishMessage}
            handleFinish={handleFinish}
        />

    </div>);
};

export default CollectionTest;
